export default __webpack_public_path__ + "media/images/home/slide_2025-2026_newtyear_sm-0f087eadd63d1e13c957a8a860bdf071.png";